import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { formatDatelll, ScrollToTop } from "../../../algorithms";
import { customStyle, styleEnd } from "../../../algorithms/styleDirection";
import { resolver } from "../../../API/middlewares/resolveRequests";
import {
  addMessage,
  getMessageRoom,
  getMessageRooms,
} from "../../../API/store/actions/auth";
import { paths } from "../../../paths/paths";
import Button from "../../sharedComponents/buttons/button";
import TextArea from "../../sharedComponents/textarea/textArea";
import Lang from "../../../userPreferences/staticWords";
import { HubConnectionBuilder } from "@microsoft/signalr";
import * as Constant from "../../../constant.module.json";
import * as signalR from "@microsoft/signalr";

const MessengerIndex = ({ routeRoomId }) => {
  const userToken = useSelector((state) => state.login.userToken);
  const userLogged = useSelector((state) => state.login.userData);
  const [inputText, setInputText] = useState("");

  const [allRooms, setAllRooms] = useState([]);
  const [currentRoom, setcurrentRoom] = useState(null);
  const [displayMessagesId, setDisplayMessagesId] = useState(null);
  useEffect(() => {
    resolver(getMessageRooms, setAllRooms, userToken);
    ScrollToTop();
  }, []);
  // const { id: roomId } = useParams();
  const [displayMessages, setDisplayMessages] = useState(null);
  useEffect(() => {
    if (currentRoom) {
      setDisplayMessages([...currentRoom?.data?.inboxMessage]);
    }
  }, [currentRoom]);
  useEffect(() => {
    if (allRooms) {
      if (displayMessagesId) {
        resolver(getMessageRoom, setcurrentRoom, displayMessagesId, userToken);
      }
    }
  }, [allRooms, displayMessagesId]);

  useEffect(() => {
    if (!routeRoomId && allRooms?.data) {
      setDisplayMessagesId(allRooms?.data[0]?.id);
    } else if (routeRoomId) {
      setDisplayMessagesId(routeRoomId);
    }
  }, [allRooms?.data]);

  useEffect(() => {
    if (allRooms && currentRoom)
      if (
        allRooms?.data?.find((item) => item.id == displayMessagesId) ==
        undefined
      )
        allRooms?.data?.unshift(currentRoom?.data);
  }, [currentRoom, allRooms, displayMessagesId]);

  //signalR
  const [connection, setConnection] = useState(null);

  useEffect(() => {
    const connect = new HubConnectionBuilder()
      .withUrl(`${Constant.hubURLProjects}/commentHub`, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .build();
    setConnection(connect);
    return () => {
      connect.stop();
    };
  }, []);
  useEffect(() => {
    if (connection && displayMessagesId) {
      // if (connection) {
      if (connection.state === "Disconnected") connection.start();
      connection.on("connected", (id) => {
        connection.invoke("JoinGroup", "messenger" + displayMessagesId);
      });
      connection.on("ReceiveComment", (message) => {
        setDisplayMessages((prev) => [...prev, message]);
      });
    }
  }, [connection, displayMessagesId]);

  // useEffect(() => {
  //   if (currentRoom?.data?.inboxMessage?.length) {
  //     setDisplayMessages({
  //       inboxMessage: [...currentRoom?.data?.inboxMessage],
  //     });
  //   }
  // }, [currentRoom?.data?.inboxMessage]);

  const sendMessage = async () => {
    const formData = new FormData();
    formData.append("Message", inputText);
    formData.append("RoomId", displayMessagesId);
    formData.append("SenderId", userLogged?.memberId);
    setInputText("");
    let res = await addMessage(formData, userToken);

    if (connection && res.status <= 206) {
      await connection.invoke(
        "SendMessage",
        res?.data,
        "messenger" + displayMessagesId
      );
      // setDisplayMessages({
      //   inboxMessage: [...displayMessages.inboxMessage, res.data],
      // });
    }
  };

  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView();
  };
  // { behavior: "smooth" }

  useEffect(() => {
    scrollToBottom();
  }, [displayMessages]);

  return (
    <div className="d-flex my-4">
      <div
        id="scroll1"
        className={`scroll1 d-flex flex-column col-md-3 col-12 ${customStyle(
          "fixedClass1"
        )} overflow-auto`}
        style={{
          height: "75vh",
        }}
      >
        {allRooms?.data?.length &&
          allRooms?.data?.map((item, index) => {
            let userPhoto, senderPhoto;
            if (item.recieverLogo != null)
              userPhoto = `url("${paths.Members}${item.recieverId}/${item.recieverLogo}") center center / cover no-repeat`;
            else
              userPhoto = `url("/assets/images/userPlaceholder.png") center center / cover no-repeat`;
            if (item.senderPhoto != null)
              senderPhoto = `url("${paths.Members}${item.senderId}/${item.senderPhoto}") center center / cover no-repeat`;
            else
              senderPhoto = `url("/assets/images/userPlaceholder.png") center center / cover no-repeat`;
            let slicedMessage = item?.inboxMessage?.message;
            if (
              item?.inboxMessage?.message !== null &&
              item?.inboxMessage?.message?.length > 30
            ) {
              const message = item?.inboxMessage?.message;
              slicedMessage = message.substring(0, 30).concat(" ... ");
            }
            return (
              <div
                className="d-flex flex-column col-12 px-3 hoverLinks text-decoration-none"
                onClick={() => {
                  setDisplayMessagesId(item?.id);
                }}
                style={{ cursor: "pointer" }}
              >
                {item.senderId == userLogged?.memberId ? (
                  <div
                    className={`d-flex px-3 py-2 justify-content-center align-items-center ${
                      displayMessagesId == item?.id ? "activeRoom" : ""
                    }`}
                    style={{ wordBreak: "break-word" }}
                  >
                    <div
                      style={{ display: "contents" }}
                      className="align-items-start col-2"
                    >
                      <div
                        style={{
                          backgroundColor: "white",
                          borderRadius: "50%",
                        }}
                        className="d-flex justify-content-center text-center align-items-center my-1 mx-2"
                      >
                        <div
                          style={{
                            backgroundSize: "contain",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            background: userPhoto,
                            height: 70,
                            width: 70,
                            opacity: 1,
                          }}
                        ></div>
                      </div>
                    </div>
                    <div className="col-10">
                      <div
                        className={`d-flex py-2 col-12 justify-content-center align-items-center`}
                      >
                        <div className="col">
                          <div
                            style={{ display: "contents" }}
                            className="col-12 d-flex align-items-start mb-2"
                          >
                            <div style={{ fontSize: 20, fontWeight: "bold" }}>
                              {item.recieverName}
                            </div>
                          </div>
                          <div style={{ fontSize: 14 }}>
                            {formatDatelll(item?.createDate)}
                          </div>
                          <div
                            className={`${styleEnd("p", 3)}`}
                            style={{ fontSize: 18 }}
                          >
                            {slicedMessage}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className={`d-flex px-3 py-2 justify-content-center align-items-center ${
                      displayMessagesId == item?.id ? "activeRoom" : ""
                    }`}
                    style={{ wordBreak: "break-word" }}
                  >
                    <div
                      style={{ display: "contents" }}
                      className="align-items-start col-2"
                    >
                      <div
                        style={{
                          backgroundColor: "white",
                          borderRadius: "50%",
                        }}
                        className="d-flex justify-content-center text-center align-items-center my-1 mx-2"
                      >
                        <div
                          style={{
                            background: senderPhoto,
                            height: 70,
                            width: 70,
                            opacity: 1,
                            backgroundSize: "contain",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                          }}
                        ></div>
                      </div>
                    </div>

                    <div className="col-10">
                      <div
                        className={`d-flex py-2 col-12 justify-content-center align-items-center`}
                      >
                        <div className="col">
                          <div
                            style={{ display: "contents" }}
                            className="col-12 d-flex align-items-start mb-2"
                          >
                            <div style={{ fontSize: 20, fontWeight: "bold" }}>
                              {item.senderName}
                            </div>
                          </div>
                          <div style={{ fontSize: 14 }}>
                            {formatDatelll(item?.createDate)}
                          </div>
                          <div
                            className={`${styleEnd("p", 3)}`}
                            style={{ fontSize: 18 }}
                          >
                            {slicedMessage}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {allRooms?.data?.length - index - 1 > 0 && (
                  <hr className="col-12" />
                )}
              </div>
            );
          })}
      </div>
      {displayMessages?.length ? (
        <div
          id="scroll2"
          className={`scroll2 d-flex flex-column col-md-7 px-3 col-12 ${customStyle(
            "fixedClass2"
          )} overflow-auto `}
          style={{
            height: "60vh",
          }}
        >
          {displayMessages?.map((item, index) => {
            let userPhoto;
            if (item.senderPhoto != null)
              userPhoto = `url("${paths.Members}${item.senderId}/${item.senderPhoto}")`;
            else userPhoto = `url("/assets/images/userPlaceholder.png")`;
            return (
              <>
                {item.senderId == userLogged?.memberId ? (
                  <div
                    key={item?.id}
                    style={{
                      backgroundColor: "#0084FE",
                      height: "fit-content",
                      borderRadius: 18,
                      color: "white",
                      wordBreak: "break-word",
                    }}
                    className="py-2 my-2 px-3 col-8"
                  >
                    <div
                      className={`d-flex py-2 col-12 justify-content-center align-items-center`}
                    >
                      <div
                        style={{
                          backgroundColor: "white",
                          borderRadius: "50%",
                        }}
                        className="d-flex justify-content-center text-center align-items-center my-1 mx-2"
                      >
                        <div
                          style={{
                            background: userPhoto,
                            height: 60,
                            width: 60,
                            opacity: 1,
                            backgroundSize: "contain",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                          }}
                        ></div>
                      </div>

                      <div className="col">
                        <div
                          style={{ display: "contents" }}
                          className="col-12 d-flex align-items-start mb-2"
                        >
                          <div style={{ fontSize: 20, fontWeight: "bold" }}>
                            {item.senderName}
                          </div>
                        </div>
                        <div className={`${styleEnd("p", 3)}`}>
                          {item.message}
                        </div>
                      </div>
                      <div>{formatDatelll(item?.createDate)}</div>
                    </div>
                  </div>
                ) : (
                  <div
                    key={item?.id}
                    style={{
                      backgroundColor: "rgb(242, 242, 242)",
                      height: "fit-content",
                      borderRadius: 14,
                      color: "black",
                      wordBreak: "break-word",
                    }}
                    className="py-2 my-2 px-3 col-8 d-flex align-self-end"
                  >
                    <div
                      className={`d-flex py-2 col-12 justify-content-center align-items-center`}
                    >
                      <div
                        style={{
                          backgroundColor: "white",
                          borderRadius: "50%",
                        }}
                        className="d-flex justify-content-center text-center align-items-center my-1 mx-2"
                      >
                        <div
                          style={{
                            background: userPhoto,
                            height: 60,
                            width: 60,
                            opacity: 1,
                            backgroundSize: "contain",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                          }}
                        ></div>
                      </div>

                      <div className="col">
                        <div
                          style={{ display: "contents" }}
                          className="col-12 d-flex align-items-start mb-2"
                        >
                          <div style={{ fontSize: 20, fontWeight: "bold" }}>
                            {item.senderName}
                          </div>
                        </div>
                        <div className={`${styleEnd("p", 3)}`}>
                          {item.message}
                        </div>
                      </div>
                      <div>{formatDatelll(item?.createDate)}</div>
                    </div>
                  </div>
                )}
                <div ref={messagesEndRef}></div>
              </>
            );
          })}
        </div>
      ) : (
        <div
          id="scroll2"
          className={`scroll2 d-flex flex-column col-md-7 px-3 col-12 ${customStyle(
            "fixedClass2"
          )} overflow-auto `}
          style={{
            height: "32%",
          }}
        >
          <div className="text-center m-auto">لا يوجد رسائل</div>
        </div>
      )}
      <div
        style={{
          position: "fixed",
          bottom: 20,
          left: "7%",
        }}
        className="col-7"
      >
        <TextArea
          placeholderAR="أكتب رسالة"
          placeholderEN="Write a message"
          rows="3"
          className="scroll col-12"
          onChange={(input) => {
            setInputText(input.target.value);
          }}
          value={inputText}
        />
        <Button
          containerStyle={"mt-2"}
          onClick={sendMessage}
          disable={!inputText}
          content={Lang.send}
        />
      </div>
    </div>
  );
};
export default MessengerIndex;
